import { api } from './client';

export async function fetchTopMarkets() {
  const { data } = await api.get('/v1/markets/top');
  return {
    items: Array.isArray(data?.data) ? data.data : [],
    cachedAt: data?.cached_at ?? null,
  };
}
